export default {
  data() {
    return {
      popupText: "Copy to clipboard"
    };
  },
  methods: {
    shareToFacebook(slug) {
      window.FB.ui(
        {
          method: "share",
          href: `https://www.d3rriana.com/blog/a/${slug}`
        },
        function(response) {}
      );
    },
    shareToTwitter(slug) {
      var shareURL = "http://twitter.com/share?";
      var params = {
        url: `https://www.d3rriana.com/blog/a/${slug}`,
        text: this.title
      };
      for (var prop in params)
        shareURL += "&" + prop + "=" + encodeURIComponent(params[prop]);
      window.open(
        shareURL,
        "",
        "left=0,top=0,width=550,height=450,personalbar=0,toolbar=0,scrollbars=0,resizable=0"
      );
    },
    shareToLinkedin(slug) {
      var url = `https://www.d3rriana.com/blog/a/${slug}`;
      var title = this.title;
      window.open(
        "http://www.linkedin.com/shareArticle?mini=true&url=" +
          encodeURIComponent(url),
        "",
        "left=0,top=0,width=650,height=420,personalbar=0,toolbar=0,scrollbars=0,resizable=0"
      );
    },
    copytoClipboard(slug) {
      navigator.clipboard.writeText(
        `https://www.d3rriana.com/blog/a/${slug}`
      );
      this.popupText = "Copied!";
    },
    changePopupText() {
      setTimeout(() => {
        this.popupText = "Copy to clipboard";
      }, 300);
    }
  }
};
